import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  showDrawer: false,
  showHistoryDrawer: false,
};

const drawerSlice = createSlice({
  name: "drawer",
  initialState,
  reducers: {
    closeDrawer: (state, _action) => {
      state.showDrawer = false;
    },
    openDrawer: (state, _action) => {
      state.showDrawer = true;
    },
    toggleDrawer: (state, _action) => {
      state.showDrawer = !state.showDrawer;
    },
    closeHistoryDrawer: (state, _action) => {
      state.showHistoryDrawer = false;
    },
    openHistoryDrawer: (state, _action) => {
      state.showHistoryDrawer = true;
    },
    toggleHistoryDrawer: (state, _action) => {
      state.showHistoryDrawer = !state.showHistoryDrawer;
    },
  },
});

export const {
  closeDrawer,
  openDrawer,
  toggleDrawer,
  closeHistoryDrawer,
  openHistoryDrawer,
  toggleHistoryDrawer,
} = drawerSlice.actions;

export default drawerSlice.reducer;
